import React from 'react'
import { Navbar, Container} from 'react-bootstrap'
import { Footer} from 'components'
import brandLogo from 'images/igiv-logo-small.png'

export default function AppLayout({ children }) {
  return (
    <>
      <Navbar bg='light' expand='lg'>
        <Container>
          <Navbar.Brand>
            <img src={brandLogo} height={40} alt='igiv logo' />
          </Navbar.Brand>
        </Container>
      </Navbar>
      <main className='my-5'>{children}</main>
      <Footer />
    </>
  )
}
